// externals
import { useState } from 'react';

const useGTPRulesModal = () => {
    const [showModal, setShowModal] = useState(false);
    return {
        showModal,
        openModal: () => setShowModal(true),
        closeModal: () => setShowModal(false)
    };
};

export default useGTPRulesModal;
